import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = ({ cartItemsCount = 0 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/shop', label: 'Shop' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/favicon.png" 
              alt="Brainwave Architectural Projects" 
              className="h-14 w-14 object-contain"
            />
            <div className="flex flex-col leading-tight">
              <span className="text-base font-bold tracking-wide" style={{ color: '#00CED1' }}>BRAINWAVE</span>
              <span className="text-[10px] tracking-[0.2em]" style={{ color: '#00CED1' }}>ARCHITECTURAL PROJECTS</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-all duration-300 hover:scale-105 ${
                  isActive(link.path)
                    ? 'font-bold'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
                style={isActive(link.path) ? { color: '#00CED1' } : {}}
              >
                {link.label}
              </Link>
            ))}
            
            <Link to="/cart" className="relative">
              <Button 
                variant="outline" 
                size="icon"
                className="relative hover:scale-105 transition-transform"
                style={{ borderColor: '#00CED1', color: '#00CED1' }}
              >
                <ShoppingCart className="h-5 w-5" />
                {cartItemsCount > 0 && (
                  <span 
                    className="absolute -top-2 -right-2 h-5 w-5 rounded-full text-white text-xs flex items-center justify-center font-bold"
                    style={{ backgroundColor: '#FF0000' }}
                  >
                    {cartItemsCount}
                  </span>
                )}
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2">
            <Link to="/cart" className="relative">
              <Button 
                variant="outline" 
                size="icon"
                style={{ borderColor: '#00CED1', color: '#00CED1' }}
              >
                <ShoppingCart className="h-5 w-5" />
                {cartItemsCount > 0 && (
                  <span 
                    className="absolute -top-2 -right-2 h-5 w-5 rounded-full text-white text-xs flex items-center justify-center font-bold"
                    style={{ backgroundColor: '#FF0000' }}
                  >
                    {cartItemsCount}
                  </span>
                )}
              </Button>
            </Link>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 rounded-md"
              style={{ color: '#00CED1' }}
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive(link.path)
                      ? 'font-bold'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                  style={isActive(link.path) ? { color: '#00CED1', backgroundColor: '#00CED110' } : {}}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
